import { jsx as c } from "react/jsx-runtime";
import { c as p } from "./clsx-OuTLNxxd.js";
const d = "_text_9m001_1", s = {
  text: d,
  "is-small": "_is-small_9m001_7",
  "is-ellipsis": "_is-ellipsis_9m001_11",
  "color-primary": "_color-primary_9m001_19",
  "color-secondary": "_color-secondary_9m001_22",
  "color-tertiary": "_color-tertiary_9m001_25",
  "color-eco-green": "_color-eco-green_9m001_28",
  "color-success": "_color-success_9m001_31",
  "color-error": "_color-error_9m001_34",
  "color-inverted": "_color-inverted_9m001_37",
  "is-bold": "_is-bold_9m001_40",
  "size-xs": "_size-xs_9m001_43",
  "size-sm": "_size-sm_9m001_46",
  "size-base": "_size-base_9m001_49",
  "size-lg": "_size-lg_9m001_52",
  "size-xl": "_size-xl_9m001_55"
};
function g({
  children: m,
  dangerouslySetInnerHTML: _,
  isSmall: t,
  ellipsis: a,
  isSpan: x,
  className: n = "",
  color: o,
  isBold: z,
  size: e,
  ...r
}) {
  const l = p(
    s.text,
    t && s["is-small"],
    a && s["is-ellipsis"],
    o && s[`color-${o}`],
    z && s["is-bold"],
    e && s[`size-${e}`],
    n
  ), i = x ? "span" : "div";
  return _ ? /* @__PURE__ */ c(i, { className: l, dangerouslySetInnerHTML: _, ...r }) : /* @__PURE__ */ c(i, { className: l, ...r, children: m });
}
export {
  g as T,
  s
};
